import { render } from "./AdminLayoutComponent.vue?vue&type=template&id=8bb3ed46"
import script from "./AdminLayoutComponent.vue?vue&type=script&lang=js"
export * from "./AdminLayoutComponent.vue?vue&type=script&lang=js"

import exportComponent from "/builds/kinarya-jqdev/jqdev/admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__